import { apiFetchAccounts } from './apiAccounts';
import { normalizeRef } from '@/lib/utils/normalizeRef';

export type ViewContext = {
  source?: string;
  council?: string;
  [key: string]: unknown;
};

export type ViewedItem = {
  reference_no: string;
  application_uid?: string | null;
  source_council?: string | null;
  source_system?: string | null;
  first_viewed_at: string;
  last_viewed_at: string;
  view_count: number;
  context?: ViewContext | null;
  description?: string | null;
  address?: string | null;
  status?: string | null;
  received_date?: string | null;
  validated_date?: string | null;
};

const appendCouncilQuery = (path: string, council?: string) =>
  council ? `${path}${path.includes('?') ? '&' : '?'}council=${encodeURIComponent(council)}` : path;

export async function recordView(referenceNo: string, context?: ViewContext) {
  const normalized = normalizeRef(referenceNo) ?? referenceNo;
  if (!normalized) return;
  return apiFetchAccounts(appendCouncilQuery(`/views/${encodeURIComponent(normalized)}`, context?.council), {
    method: 'PUT',
    body: JSON.stringify(context ? { context } : {}),
  });
}

export async function listViews(limit = 50, council?: string): Promise<ViewedItem[]> {
  return apiFetchAccounts(appendCouncilQuery(`/views?limit=${limit}`, council), { method: 'GET' });
}

export async function removeView(referenceNo: string, council?: string) {
  const normalized = normalizeRef(referenceNo) ?? referenceNo;
  if (!normalized) return;
  return apiFetchAccounts(appendCouncilQuery(`/views/${encodeURIComponent(normalized)}`, council), {
    method: 'DELETE',
  });
}

export async function clearViews(council?: string) {
  return apiFetchAccounts(appendCouncilQuery('/views', council), { method: 'DELETE' });
}

export async function viewsCount(council?: string): Promise<{ total_views: number; distinct_refs: number }> {
  return apiFetchAccounts(appendCouncilQuery('/views/count', council), { method: 'GET' });
}
